import React from 'react';
import { Row, Col, Container} from 'react-bootstrap';
//CSS
import './style.css';

export default function RoadMap(props){
    return(
        <section id={props.id} className="roadmap section-padding-100">
            <Container>
                <div className="section-heading text-center">
                    <h2>{props.title}</h2>
                    <p>{props.text}</p>
                </div>
                <Row>
                    <div className="timeline-split">
                        <Col lg={12} md={12} sm={12}>
                            <div className="timeline section-box-margin">
                                {props.roadMap.map((item, i)=>
                                    <div className={`block shadow block-${(i+1)%2 === 0 ? 'right':'left'} ${i>0?'mt-30':''}`} key={i}>
                                        {item.title.split(' \n ').map((line, i) => <h3 key={i}>{line}</h3>)}
                                        <span className="date shadow">{item.dateOne}</span> <span className="between">até</span> <span className="date shadow">{item.dateTwo}</span>
                                        {item.text.split(' \n ').map((line, i) => <p key={i}>{line}</p>)}
                                    </div>
                                )}
                                <div className="circle"></div>
                            </div>
                        </Col>
                    </div>
                </Row>
            </Container>
        </section>
    );
}